import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromSharing from './sharing.reducer';
import { State } from './';

const selectSharingModuleState = createFeatureSelector<State>(fromSharing.SharingFeatureKey);

export const selectConfiguredChannels = createSelector(selectSharingModuleState, fromSharing.getConfiguredChannels);

export const selectCommunicationTemplates = createSelector(selectSharingModuleState, fromSharing.getCommunicationTemplates);

export const selectShowShareDocumentDialog = createSelector(selectSharingModuleState, fromSharing.getShowShareDocumentDialog);

export const selectSelectedTemplate = createSelector(selectSharingModuleState, fromSharing.getSelectedTemplate);

export const selectSelectedChannel = createSelector(selectSharingModuleState, fromSharing.getSelectedChannel);

export const selectCommunicationTemplatePreview = createSelector(selectSharingModuleState, fromSharing.getCommunicationTemplatePreview);

export const selectDocumentCommunicationActivity = createSelector(selectSharingModuleState, fromSharing.getDocumentCommunicationActivity);

export const selectHistoricCommunication = createSelector(selectSharingModuleState, fromSharing.getHistoricCommunication);

export const selectEmailSummariesForDocument = createSelector(selectSharingModuleState, fromSharing.getEmailSummariesForDocument);

export const selectIsEmailWorking = createSelector(selectSharingModuleState, fromSharing.getIsEmailWorking);

export const selectShowHistoricCommunication = createSelector(selectSharingModuleState, fromSharing.getShowHistoricCommunication);

export const selectShowShareDocumentEverbridgeDialog = createSelector(selectSharingModuleState, fromSharing.getShowShareDocumentEverbridgeDialog);

export const selectEverbridgeTemplates = createSelector(selectSharingModuleState, fromSharing.getEverbridgeTemplates);

export const selectSelectedEverbridgeTemplatePreview = createSelector(selectSharingModuleState, fromSharing.getSelectedEverbridgeTemplatePreview);

export const selectSelectedEverbridgeTemplate = createSelector(selectSharingModuleState, fromSharing.getSelectedEverbridgeTemplate);

export const selectShowHistoricMassNotification = createSelector(selectSharingModuleState, fromSharing.getShowHistoricMassNotification);
